var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-quantity"},[_c('base-input-number',{attrs:{"name":_vm.$t('Quantity'),"value":_vm.value,"min":1,"max":_vm.max,"disabled":_vm.disabled,"only-positive":"","validations":[
      {
        condition: !_vm.$v.value.numeric || !_vm.$v.value.minValue || !_vm.$v.value.required,
        text: _vm.$t(`Quantity must be positive integer`)
      }
    ]},on:{"input":function($event){return _vm.$emit('input', $event)},"blur":function($event){return _vm.$v.$touch()}}}),(_vm.loading)?_c('spinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }